import React, { useEffect, useState } from "react";
import "./style.scss";
import ReactFlagsSelect from "react-flags-select";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { State } from "../../app/store";

interface IProps {
  isMobile?: boolean;
}

const LanguageSelect: React.FC<IProps> = ({ isMobile = false }) => {
  const saleConfiguration = useSelector((state: State) => state.config.configuration);
  const { i18n } = useTranslation();
  const [searchParams] = useSearchParams();
  const [language, setLanguage] = useState(i18n.language);

  useEffect(() => {
    setLanguage(i18n.language);
  }, [i18n.language]);

  useEffect(() => {
    const langParam = searchParams.get("lang");
    switch (langParam?.toLocaleLowerCase()) {
      case "pl":
        i18n.changeLanguage("PL");
        break;
      case "en":
        i18n.changeLanguage("GB");
        break;
      case "de":
        i18n.changeLanguage("DE");
        break;
      case "ua":
        i18n.changeLanguage("UA");
        break;
      default:
        return;
    }
    //eslint-disable-next-line
  }, [searchParams]);

  const countries = ["PL", "GB", "DE", "UA"];

  const customLabels = {
    PL: { primary: "PL" },
    GB: { primary: "EN" },
    DE: { primary: "DE" },
    UA: { primary: "UA" },
  };

  const onChangeLanguage = (value: string) => {
    i18n.changeLanguage(value);
    window.location.reload();
  };

  return (
    <>
      {saleConfiguration.languageSelectActive && (
        <>
          {!isMobile ? (
            <div className={"language-select-wrapper"}>
              <ReactFlagsSelect
                selected={language}
                onSelect={(value: string) => onChangeLanguage(value)}
                countries={countries}
                customLabels={customLabels}
                className={""}
              />
            </div>
          ) : (
            <ReactFlagsSelect
              selected={language}
              onSelect={(value: string) => onChangeLanguage(value)}
              countries={countries}
              customLabels={customLabels}
              className="react-flags-select-mobile"
            />
          )}
        </>
      )}
    </>
  );
};

export default LanguageSelect;
